import { render, staticRenderFns } from "./rates.vue?vue&type=template&id=1783919b&"
import script from "./rates.vue?vue&type=script&lang=js&"
export * from "./rates.vue?vue&type=script&lang=js&"
import style0 from "./rates.vue?vue&type=style&index=0&id=1783919b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports